import { QueryClient } from '@tanstack/react-query';
import { toast } from '../components/ui/use-toast';

export const queryClient = new QueryClient({
    defaultOptions: {
        queries: {
            staleTime: 5 * 60 * 1000,
            gcTime: 10 * 60 * 1000,
            retry: (failureCount, error) => {
                if (error instanceof Error && error.message.includes('4')) {
                    return false;
                }
                return failureCount < 2;
            },
            refetchOnWindowFocus: false,
        },
        mutations: {
            onError: (error) => {
                toast({
                    variant: 'destructive',
                    title: 'Error',
                    description: error instanceof Error ? error.message : 'An error occurred',
                });
            },
        },
    },
});
